<template>
  <div class="wrapper">
    <div class="section">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item  md-xsmall-size-100 mx-auto text-center">
            <h2 class="title text-center">
              Messages clients
            </h2>

            <div class="w-full table-container">
              <table class="w-full">
                <thead class="flex w-full entete">
                  <tr class="flex w-full ">
                    <th class="no  text-black ">
                      No
                    </th>
                    <th class="nom  text-black ">
                      Nom complet
                    </th>
                    <th class="email  text-black">
                      Email
                    </th>
                    <th class="phone  text-black">
                      Telephone
                    </th>
                    <th class="message  text-black">
                      Message
                    </th>
                    <th class="date  text-black">
                      Date
                    </th>
                  </tr>
                </thead>
                <div v-if="donne.length === 0" class="ras ">
                  Aucun article publié
                </div>
                <tbody
                  class="bg-white items-center w-full mt-10"
                  style="height: 94vh"
                >
                  <tr
                    v-for="(item, index) in donne"
                    :key="index"
                    @click="selected(index)"
                    class="flex w-full user_item cursor-pointer"
                    :class="{ is_selected: item.isRead === false }"
                  >
                    <td class="no text-xs  pt-2">
                      {{ index + 1 }}
                    </td>
                    <td class="nom text-xs  pt-2">
                      {{ item.name }}
                    </td>
                    <td class="email text-xs  pt-2">
                      {{ item.email }}
                    </td>
                    <td class="phone text-xs  pt-2">
                      {{ item.phone }}
                    </td>
                    <td class="message  pt-2 pl-2">
                      <span v-if="position !== index">{{
                        item.message.substr(0, 20)
                      }}</span>
                      <span
                        v-if="item.message.length > 20 && position !== index"
                        >...</span
                      >
                      <span v-if="position === index">{{ item.message }}</span>
                    </td>

                    <td class="date  pt-2">
                      {{ convert(item.createdAt) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { db } from "@/main";
export default {
  bodyClass: "etude",
  components: {},
  data() {
    return {
      locations: [],
      position: -1
    };
  },
  computed: {
    donne: function() {
      return this.locations;
    }
  },
  methods: {
    selected(index) {
      this.position = index;
      this.donne[index].isRead = true;
      let choix = this.donne[index];
      if (choix.isRead === false) {
        db.collection("newLetters")
          .doc(choix.id)
          .update({
            isRead: true
          })
          .then(response => {
            console.log("success");
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
      }
    },
    convert(value) {
      var date = new Date(value);
      return date.toLocaleDateString("en-gb");
    }
  },
  created() {
    db.collection("newLetters")
      .get()
      .then(response => {
        response.forEach(doc => {
          // doc.data() is never undefined for query doc snapshots
          this.locations.push(doc.data());
        });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
.title {
  margin-top: 100px;
}
.table-container {
  width: 100%;
}
.nom {
  width: 30%;
  text-align: left;
}
.no {
  width: 5%;
  text-align: center;
}
.email {
  width: 20%;
  text-align: left;
}
.phone {
  width: 15%;
  text-align: left;
}
.message {
  width: 40%;
}
.date {
  width: 10%;
  text-align: right;
}
table {
  width: 100%;
}
.entete {
  background-color: #dedede;
}
.user_item {
  cursor: pointer;
}
.is_selected.user_item {
  background-color: #d7e5e5;
  cursor: pointer;
}

.ras {
  width: 100%;
}
</style>
